import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const KIND = { purchase: "#22e3a1", promo_bonus: "#22e3a1", limit_bonus: "#22e3a1", winback_bonus: "#22e3a1", refund: "#ff5a8a", consume: "#94a3b8", clip_refund: "#3ad7ff", gift_code: "#22e3a1", gift_admin: "#22e3a1", challenge: "#22e3a1", referral: "#22e3a1", referral_welcome: "#22e3a1" };

export const CreditLedger = ({ reloadKey }) => {
  const { t, lang } = useI18n();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/credits/ledger").then((r) => setRows(r.data)).catch(() => {}); }, [reloadKey]);
  return (
    <div className="mt-4 space-y-1.5" data-testid="credits-ledger">
      {!rows.length && <p className="text-sm text-slate-500">{t("cr.no_ledger")}</p>}
      {rows.map((r, i) => (
        <div key={i} className="cx-card rounded-xl px-4 py-2.5 flex items-center gap-3 text-sm" data-testid={`ledger-row-${i}`}>
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: KIND[r.kind] || "#94a3b8" }} />
          <span className="text-white flex-1">{t(`cr.k_${r.kind}`)}{r.code ? <span className="ml-2 font-mono text-[11px] text-slate-500" data-testid={`ledger-code-${i}`}>{r.code}</span> : null}</span>
          <span className={`font-mono ${r.delta > 0 ? "text-[#22e3a1]" : "text-slate-400"}`}>{r.delta > 0 ? "+" : ""}{r.delta}</span>
          <span className="text-slate-500 text-xs w-24 text-right">{new Date(r.created_at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA")}</span>
        </div>
      ))}
    </div>
  );
};
